/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useState, type ReactElement } from 'react'
import React from 'react'

import { EuiLink } from '@elastic/eui'

import type { LineItem } from '@modules/billing-api/customTypes'
import { FormattedMessage } from '@modules/i18n'

import LineItemFlyout from './LineItemFlyout'

const LineItemDetails = ({ lineItem }: { lineItem: LineItem }): ReactElement => {
  const [isFlyoutVisible, setIsFlyoutVisible] = useState(false)

  const closeFlyout = () => setIsFlyoutVisible(false)
  const showFlyout = () => setIsFlyoutVisible(true)

  return (
    <div>
      <EuiLink onClick={showFlyout} data-test-id='details-link'>
        <FormattedMessage id='prepaid-account-details-popover.details' defaultMessage='Details' />
      </EuiLink>
      {isFlyoutVisible && <LineItemFlyout lineItem={lineItem} onClose={closeFlyout} />}
    </div>
  )
}

export default LineItemDetails
